module.exports = __webpack_public_path__ + "img/popupAd-day0.16c19a68.png";